export var findNotDisabledElement = function findNotDisabledElement(_ref) {
  var target = _ref.target,
      reverse = _ref.reverse,
      startWithTarget = _ref.startWithTarget;
  var sibling = reverse ? target.previousElementSibling : target.nextElementSibling;
  var element = startWithTarget ? target : sibling;

  if (!element) {
    return null;
  }

  if (typeof element.getAttribute('disabled') === 'string') {
    return findNotDisabledElement({
      target: element,
      reverse: reverse
    });
  }

  return element;
};